// === DashboardTeacher.js ===
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import BaseLayout from './BaseLayout';
import ForceLogoutRedirect from './ForceLogoutRedirect';
import MyVisits from './MyVisits';
import TeacherHome from './TeacherHome';
import MyStudentsSkills from './MyStudentsSkills';
import SubstituteStudentsSkills from './SubstituteStudentsSkills';
import MyStudentsInfo from './MyStudentsInfo';
import MyReports from './MyReports';
import MyAvailability from './MyAvailability';
import TeacherDocuments from './TeacherDocuments';
import StudentAchievement from './StudentAchievement';
import MyTimeLog from './MyTimeLog';
import MyStudentsAvailability from './MyStudentsAvailability';
import TeacherDayPlannerSelf from './TeacherDayPlannerSelf';
import MyTrainees from './MyTrainees';
import Messages from './Messages';
import AboutHelp from './AboutHelp';
import Faq from './Faq';
import TeacherVisitsCalendar from './TeacherVisitsCalendar';

// ✅ NOVO: Instruments (teacher)
import TeacherInstruments from './TeacherInstruments';
import InstrumentWorkspace from './InstrumentWorkspace';

import MyTripLogs from './MyTripLogs';


const DashboardTeacher = () => {
  const location = useLocation();

  return (
    <BaseLayout role="teacher">
      <Routes location={location}>
        <Route path="/" element={<TeacherHome />} />
        <Route path="visits" element={<MyVisits />} />
        <Route path="calendar" element={<TeacherVisitsCalendar />} />
        <Route path="students" element={<MyStudentsSkills />} />
        <Route path="substitute" element={<SubstituteStudentsSkills />} />
        <Route path="students-info" element={<MyStudentsInfo />} />
        <Route path="reports" element={<MyReports />} />
        <Route path="availability" element={<MyAvailability />} />
        <Route path="students-availability" element={<MyStudentsAvailability mode="teacher" />} />
        <Route path="my-planner" element={<TeacherDayPlannerSelf />} />
        <Route path="my-trainees" element={<MyTrainees />} />

        <Route path="docs" element={<TeacherDocuments />} />

        <Route path="achievement" element={<StudentAchievement mode="teacher" />} />
        <Route path="my-timelog" element={<MyTimeLog />} />
	    <Route path="my-triplog" element={<MyTripLogs />} />
        <Route path="messages" element={<Messages />} />

        {/* ✅ NOVO: Instruments */}
        <Route path="instruments/*" element={<TeacherInstruments />} />
		<Route path="instrument-submissions/:id" element={<InstrumentWorkspace />} />

        <Route path="about" element={<AboutHelp mode="teacher" />} />
        <Route path="faq" element={<Faq mode="teacher" />} />

        <Route path="*" element={<ForceLogoutRedirect />} />
      </Routes>
    </BaseLayout>
  );
};

export default DashboardTeacher;




